import React, { useEffect, useState } from 'react'
import SingleComment from './SingleComment'

interface Props {
	commentsIds: number[]
}

const ShowComments: React.FC<Props> = ({ commentsIds }) => {
	const [toggleComments, setShowComments] = useState(false)
	const [commentsDisplay, setCommentsDisplay] = useState('none')

	let showCommentsCSS: { display: string } = {
		display: commentsDisplay,
	}

	useEffect(() => {
		if (toggleComments) {
			setCommentsDisplay('block')
		} else {
			setCommentsDisplay('none')
		}
	}, [toggleComments])

	return (
		<div>
			<button
				onClick={() => setShowComments(!toggleComments)}
				className="show-comments-btn text-salmon">
				Show Comments ({commentsIds.length})
			</button>
			<div style={showCommentsCSS}>
				<ul>
					{commentsIds.map((id) => {
						if (id) {
							return (
								<SingleComment
									id={id}
									toggle={toggleComments}
									key={id}
								/>
							)
						} else {
							return <li>Comment Not Found</li>
						}
					})}
				</ul>
				<div className=" h-small flex-center">
					<button
						onClick={() => setShowComments(!toggleComments)}
						className="show-comments-btn text-salmon">
						Hide Comments
					</button>
				</div>
			</div>
		</div>
	)
}

export default ShowComments
